<p-card styleClass="gallery">
  <ng-template pTemplate="header">
    <div *ngIf="!product?.medias || product?.medias?.length === 0" class="no-img">
      <i class="pi pi-image"></i>
    </div>
    <div >
      <p-galleria [value]="product.medias || []" [numVisible]="3" [responsiveOptions]="responsiveOptions"
        [showThumbnails]="false" [showIndicators]="true" [changeItemOnIndicatorHover]="true"
        indicatorsPosition="bottom">
        <ng-template pTemplate="item" let-media>
          <div (click)="onSelectProductMedia(media)" onkeypress="">
            <img *ngIf="media.fileType === 'doc'" src="assets/images/pdf.svg"  alt=""/>
            <img *ngIf="media.fileType !== 'doc'" src="{{ media?.url}}" alt="" />
          </div>
        </ng-template>
        <!-- <ng-template pTemplate="thumbnail" let-media>
          <div class="p-grid p-nogutter p-justify-center" style="width: 90%;background-repeat: no-repeat; height: 100%">
            <img src="{{ media?.url }}" />
          </div>
        </ng-template>-->
      </p-galleria>
    </div>
    <div *ngIf="isPdfPreview">
      <p-dialog class="full-screen-modal" styleClass="price-list-modal" header="{{selectedDocMedia.name}}"
        [modal]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false" [(visible)]="isPdfPreview"
        (onHide)="isPdfPreview = false" width="90%" height="90%">
        <div class="pdf-height" *ngIf="selectedDocMedia?.url">
          <ngx-extended-pdf-viewer src="{{selectedDocMedia?.url}}" [zoom]="'100%'">
          </ngx-extended-pdf-viewer>
        </div>
      </p-dialog>
    </div>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="prod-name" >
      {{ product.productCode }}
    </div>
    <div class="prod-company" >
      {{ product.make }}
    </div>
    <div class="prod-shortText" >
      {{ product.shortDescription }}
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="ribbon-wrapper">
      <div class="ribbon" >
        <a>{{ product.productType?.name }}</a>
      </div>
    </div>
    <div *ngIf="!product.inCart">
      <p-button icon="pi pi-shopping-cart" (onClick)="addToCart(product)"></p-button>
    </div>
  </ng-template>
</p-card>